import router from './router'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ['/login','/403','/home'];// no redirect whitelist

router.beforeEach((to,from,next) =>{
  NProgress.start();
  next();
});


router.afterEach(() => {
  NProgress.done();
});
